module.exports = __webpack_public_path__ + "5098b2ec312165c9e5b575c17b4d0915.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/wpp.svg
// module id = OtCD
// module chunks = 0